import { useEffect, useState } from "react";

export function useProcessingProgress(active: boolean, steps: readonly string[]) {
  const [step, setStep] = useState(steps[0] ?? "Обрабатываю…");

  useEffect(() => {
    if (!active) {
      setStep(steps[0] ?? "Обрабатываю…");
      return;
    }
    setStep(steps[0] ?? "Обрабатываю…");
    const delays = [2_200, 6_000, 12_000, 22_000];
    const timers = steps.slice(1).map((label, index) => window.setTimeout(() => setStep(label), delays[index] ?? 22_000));
    return () => timers.forEach(timer => window.clearTimeout(timer));
  }, [active, steps]);

  return step;
}
